import {CurriculumByGrade} from '../components/CurriculumByGrade';
export function CurriculumTracksSection() {
  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl bg-brand-50 px-6 py-10 sm:rounded-3xl sm:px-10 sm:py-12 lg:px-14 lg:py-14">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand-600 sm:text-sm">
            See What You&rsquo;ll Learn
          </p>

          <h2 className="mt-5 max-w-2xl text-3xl font-semibold leading-[1.1] tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            A curriculum tuned to
            <br className="hidden lg:block" />{' '}
            your child&rsquo;s grade &mdash; not
            <br className="hidden lg:block" />{' '}
            a generic worksheet pile.
          </h2>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-500 sm:text-lg">
            Every class is grouped by level so the work is challenging but reachable. We rebuild last year&rsquo;s weak spots, then push a half-grade ahead of where school will pick up.
          </p>

          <CurriculumByGrade />
        </div>
      </div>
    </section>
  );
}